module.exports = __webpack_public_path__ + "resource/img/image033Dark.c8ce5b18.png";